import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const InsuranceCaseManagerPage = () => {
  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'payer', label: 'Payer' },
    { key: 'phone', label: 'Phone' },
    { key: 'fax', label: 'Fax' },
    { key: 'email', label: 'Email' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'name', label: 'Case Manager Name', type: 'text', required: true },
    { key: 'payer', label: 'Payer', type: 'select', required: true, options: [
      { value: 'Medicare', label: 'Medicare' },
      { value: 'Medicaid', label: 'Medicaid' },
      { value: 'UnitedHealthcare', label: 'UnitedHealthcare' },
      { value: 'Aetna', label: 'Aetna' },
      { value: 'BCBS', label: 'Blue Cross Blue Shield' },
      { value: 'Humana', label: 'Humana' },
      { value: 'Cigna', label: 'Cigna' },
      { value: 'Other', label: 'Other' },
    ]},
    { key: 'phone', label: 'Phone', type: 'text', required: true },
    { key: 'fax', label: 'Fax', type: 'text', required: false },
    { key: 'email', label: 'Email', type: 'email', required: false },
    { key: 'notes', label: 'Notes', type: 'textarea', required: false, fullWidth: true },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', name: 'Smith, Jennifer', payer: 'Medicare', phone: '(800) 633-4227', fax: '(800) 633-4228', email: 'jsmith@cms.gov', active: 'Yes' },
    { id: '2', name: 'Johnson, Michael', payer: 'UnitedHealthcare', phone: '(800) 328-5979', fax: '(800) 328-5980', email: 'mjohnson@uhc.com', active: 'Yes' },
    { id: '3', name: 'Williams, Sarah', payer: 'Aetna', phone: '(800) 872-3862', fax: '(800) 872-3863', email: 'swilliams@aetna.com', active: 'Yes' },
    { id: '4', name: 'Brown, David', payer: 'BCBS', phone: '(800) 521-2227', fax: '(800) 521-2228', email: 'dbrown@bcbs.com', active: 'Yes' },
    { id: '5', name: 'Davis, Lisa', payer: 'Humana', phone: '(800) 457-4708', fax: '(800) 457-4709', email: 'ldavis@humana.com', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Insurance Case Manager"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Case Manager"
      formFields={formFields}
      apiEndpoint="/setup/insurance-case-manager"
    />
  );
};

export default InsuranceCaseManagerPage;
